import { AddLink, DeleteButton, EditLink } from "app/components/buttons";
import { Column } from "app/components/column";
import { Container } from "app/components/container";
import { DFlexResponsive } from "app/components/d-flex-responsive";
import { Row } from "app/components/row";
import { Table } from "app/components/table";
import { useEmpresa } from "app/contexts";

export function CelularesTable() {
  const { empresa, deleteCelular } = useEmpresa();

  return (
    <Container>
      <Row>
        <Column>
          <DFlexResponsive justifyContent="between">
            <h5>
              <strong>Números de celular (requerido)</strong>
            </h5>

            <AddLink to="celulares/add" title="Agregar número de celular" />
          </DFlexResponsive>
        </Column>

        <Column>
          {!!empresa.celulares.length ? (
            <Table
              responsive
              titles={["#", "Tipo", "Número de celular", "Opciones"]}
            >
              {empresa.celulares.map((celular, i) => (
                <tr key={i}>
                  <td className="text-center">{i + 1}</td>

                  <td>
                    {celular.celular_principal ? "Principal" : "Secundario"}
                  </td>

                  <td>{celular.celular_numero}</td>

                  <td>
                    <DFlexResponsive>
                      <EditLink to={`celulares/${i}/edit`} />

                      <DeleteButton
                        size="sm"
                        onClick={() => deleteCelular(i)}
                      />
                    </DFlexResponsive>
                  </td>
                </tr>
              ))}
            </Table>
          ) : (
            <p className="lead text-center">
              Por favor, agregue al menos un número de celular
            </p>
          )}
        </Column>
      </Row>
    </Container>
  );
}
